import AdminCreateCompany from "../components/AdminCreateCompany";
import useAdminCreateCompany from "../hooks/useAdminCreateCompany";

const AdminCreateCompanyPage = () => {
    const useAdminCreateCompanyProps = useAdminCreateCompany();
    return (
        <AdminCreateCompany {...useAdminCreateCompanyProps} />
    )
}

export default AdminCreateCompanyPage;